import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { SortingOptions } from '../../domain/models/sorting-option.model';
import { LocationsRepository } from '../../repositories';

@Injectable({ providedIn: 'root' })
export class GetSortingOptionLookupUsecase
  implements UseCase<unknown, SortingOptions[]>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(): Observable<SortingOptions[]> {
    return this.locationRepository.getSortingOptions();
  }
}
